module.exports = __webpack_public_path__ + "img/TiZhiIcon.7c8cdeb8.svg";